import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var CrossOutlineIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("mask", __assign({ id: "cross-outline_svg__a", style: {
                    maskType: "alpha",
                }, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, { children: jsx("path", { d: "M0 0h24v24H0V0z", fill: "currentColor" }) })), jsx("g", __assign({ mask: "url(#cross-outline_svg__a)" }, { children: jsx("path", { d: "M20.293 5.169a1 1 0 000-1.414l-.048-.048a1 1 0 00-1.414 0L12 10.538 5.169 3.707a1 1 0 00-1.414 0l-.047.048a1 1 0 000 1.414L10.537 12l-6.83 6.831a1 1 0 000 1.415l.047.047a1 1 0 001.414 0l6.832-6.831 6.83 6.831a1 1 0 001.414 0l.047-.047a1 1 0 000-1.415L13.463 12l6.83-6.831z", fill: "currentColor" }) }))] })));
};

export { CrossOutlineIcon };
//# sourceMappingURL=CrossOutlineIcon.js.map
